import { getItemsFromCollection } from "directus/src/operations";

export async function fetchQuickLinks() {
  try {
    const query = {
        fields: [
            "id",
            "label",
            "description",
            "url",
            "favicon",
      ],

    };
      const response = await getItemsFromCollection("quick_links", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}